// extracted by mini-css-extract-plugin
export default {"card":"m5-z"};